import * as yup from 'yup';

export default yup.object().shape({
  fullName: yup.string().nullable().required('Please provide full name'),
  email: yup.string().email('Please provide the correct email').required('Please provide email'),
  address: yup.string().nullable().required('Please provide address'),
  phone: yup
    .object()
    .required()
    .test('phone', 'Please enter a valid phone number', async (value) => {
      if (!value) {
        return false;
      }
      const sp = new URLSearchParams(value);
      const r = await fetch(`/api/phone/validate?${sp.toString()}`, {
        headers: {
          accept: 'application/json',
        },
        method: 'GET',
        credentials: 'same-origin',
      });

      return r.status === 200;
    }),
  otherAmount: yup.string().test('other-amount', 'Please provide the number', function (val) {
    const { donationAmount } = this.options.parent;
    if (donationAmount == 'other') {
      if (val > 0) {
        return true;
      }
      return false;
    }
    return true;
  }),
  recaptcha: yup
    .string()
    .nullable()
    .test('recaptcha', 'Please enter the recaptcha', async (value) => {
      if (window.showRecaptcha != 'NZ' && window.showRecaptcha != 'AUS') {
        if (!value) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }),
});
